var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterCircle = function SvgTwitterCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitterCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.476 0 0 4.476 0 10s4.476 10 10 10 10-4.476 10-10S15.524 0 10 0Zm5.029 8.105v.314c0 3.181-2.429 6.857-6.858 6.857-1.361 0-2.628-.4-3.685-1.085a4.797 4.797 0 0 0 3.562-.99A2.4 2.4 0 0 1 5.8 11.523a2.344 2.344 0 0 0 1.095-.038 2.41 2.41 0 0 1-1.933-2.362v-.029c.324.181.695.286 1.086.305A2.41 2.41 0 0 1 4.97 7.39c0-.438.124-.857.324-1.209a6.866 6.866 0 0 0 4.972 2.524 2.406 2.406 0 0 1 2.343-2.962c.695 0 1.323.286 1.761.762a5.216 5.216 0 0 0 1.534-.581 2.42 2.42 0 0 1-1.057 1.333c.485-.057.952-.19 1.38-.38a4.711 4.711 0 0 1-1.209 1.247l.01-.02Z",
    fill: "#1D9BF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitterCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgTwitterCircle;